import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "@/setup/iconLibrary.js";

function addIcons(app) {
  app.component("FontAwesomeIcon", FontAwesomeIcon);
}

export { addIcons };
